import { Wrapper, Content, Text  } from "./Footer.Styles";

const Footer = () => {
    return (
        <Wrapper>
            <Content>
                <Text>
                    <p>This web app is useing Movie DB API to fetch and display the Movie Data<br></br>This Application is a part of my Portfolio Project</p>
                </Text>
            </Content>
        </Wrapper>
    )
}

export default Footer